export const useYouTubePlayerStore = defineStore('YouTubePlayerStore', () => {
  const videoId = ref<string | null>(null);
  const videoCurrentTime = ref<number|null>(0);
  const videoIsPlaying = ref(false);
  const videoPlayerRef = ref<YT.Player | null>(null);
  const videoMainRoute = ref<string | null>(null);
  const videoCurrentRoute = ref<string | null>(null);
  const allowPip = ref<boolean>(false);

  const getYouTubeVideoId = (url?: string): string|null => {
    if(!url) {
      return null;
    }
    try {
      const parsedUrl = new URL(url)
      if (parsedUrl.hostname.includes('youtube.com') && parsedUrl.searchParams.has('v')) {
        return parsedUrl.searchParams.get('v')
      }
      if (parsedUrl.hostname === 'youtu.be') {
        return parsedUrl.pathname.slice(1)
      }
      return null
    } catch (e) {
      return null
    }
  }
  const setCurrentVideo = (videoUrlOrId?: string|null, mainRoute?: string|null) => {
    let newId;
    if(videoUrlOrId?.startsWith('http')) {
      newId = getYouTubeVideoId(videoUrlOrId);
    } else {
      newId = videoUrlOrId;
    }
    if(videoId.value !== newId) {
      videoCurrentTime.value = null;
      videoIsPlaying.value = false;
    }
    videoId.value = newId;
    videoMainRoute.value = mainRoute;
  }

  const setVideoPlayer = (player: YT.Player) => {
    videoPlayerRef.value = player
  }

  const updateVideoTimeAndStatus = () => {
    if (videoPlayerRef.value) {
      videoCurrentTime.value = videoPlayerRef.value.getCurrentTime();
      videoIsPlaying.value = videoPlayerRef.value.getPlayerState() === YT.PlayerState.PLAYING;
      allowPip.value = showAsPip.value || videoIsPlaying.value;
    }
  }

  const showAsPip = computed(() => {
    return allowPip.value && videoMainRoute.value && videoMainRoute.value !== videoCurrentRoute.value;
  })

  return {
    videoId,
    videoCurrentTime,
    videoIsPlaying,
    videoPlayerRef,
    videoMainRoute,
    videoCurrentRoute,
    showAsPip,
    setCurrentVideo,
    setVideoPlayer,
    updateVideoTimeAndStatus
  }
})
